import type { IWalletIconProps } from './helpers';

export const WalletCardIcon = ({ variant, ...rest }: IWalletIconProps) => {
	if (variant === 'NGN') {
		return (
			<svg
				width='60'
				height='60'
				viewBox='0 0 60 60'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<rect
					width='60'
					height='60'
					rx='30'
					fill='#02223D'
				/>
				<path
					d='M25.6958 29.2069V30.7932H29.4583L28.2402 29.2069H25.6958Z'
					fill='white'
				/>
				<path
					d='M34.3038 34.1063V32.6194H33.1626L34.3038 34.1063Z'
					fill='white'
				/>
				<path
					d='M25.6958 25.8938V27.3807H26.8377L25.6958 25.8938Z'
					fill='white'
				/>
				<path
					d='M30 14C21.1637 14 14 21.1637 14 30C14 38.8363 21.1637 46 30 46C38.8363 46 46 38.8363 46 30C46 21.1637 38.8363 14 30 14ZM38.4619 30.7931C38.7041 30.7931 38.9363 30.8893 39.1076 31.0606C39.2788 31.2318 39.375 31.4641 39.375 31.7062C39.375 31.9484 39.2788 32.1807 39.1076 32.3519C38.9363 32.5232 38.7041 32.6194 38.4619 32.6194H36.13V36.7944C36.1301 36.9851 36.0705 37.1711 35.9594 37.3262C35.8482 37.4813 35.6913 37.5976 35.5106 37.6588C35.4161 37.6912 35.3168 37.7076 35.2169 37.7075C35.0769 37.7075 34.9389 37.6754 34.8134 37.6135C34.6879 37.5516 34.5783 37.4617 34.4931 37.3506L30.86 32.6194H25.6962V36.7944C25.6962 36.9143 25.6726 37.033 25.6267 37.1438C25.5809 37.2546 25.5136 37.3553 25.4288 37.4401C25.344 37.5248 25.2433 37.5921 25.1326 37.638C25.0218 37.6839 24.903 37.7075 24.7831 37.7075C24.6632 37.7075 24.5445 37.6839 24.4337 37.638C24.3229 37.5921 24.2222 37.5248 24.1374 37.4401C24.0527 37.3553 23.9854 37.2546 23.9395 37.1438C23.8936 37.033 23.87 36.9143 23.87 36.7944V32.6194H21.5381C21.2959 32.6194 21.0637 32.5232 20.8924 32.3519C20.7212 32.1807 20.625 31.9484 20.625 31.7062C20.625 31.4641 20.7212 31.2318 20.8924 31.0606C21.0637 30.8893 21.2959 30.7931 21.5381 30.7931H23.87V29.2069H21.5381C21.2959 29.2069 21.0637 29.1107 20.8924 28.9394C20.7212 28.7682 20.625 28.5359 20.625 28.2937C20.625 28.0516 20.7212 27.8193 20.8924 27.6481C21.0637 27.4768 21.2959 27.3806 21.5381 27.3806H23.87V23.2056C23.8701 23.015 23.9299 22.8291 24.041 22.6742C24.152 22.5192 24.3088 22.4029 24.4893 22.3416C24.6698 22.2802 24.865 22.2769 25.0475 22.3321C25.23 22.3873 25.3906 22.4983 25.5069 22.6494L29.14 27.3806H34.3037V23.2056C34.3037 22.9634 34.4 22.7312 34.5712 22.5599C34.7424 22.3887 34.9747 22.2925 35.2169 22.2925C35.4591 22.2925 35.6913 22.3887 35.8626 22.5599C36.0338 22.7312 36.13 22.9634 36.13 23.2056V27.3806H38.4619C38.7041 27.3806 38.9363 27.4768 39.1076 27.6481C39.2788 27.8193 39.375 28.0516 39.375 28.2937C39.375 28.5359 39.2788 28.7682 39.1076 28.9394C38.9363 29.1107 38.7041 29.2069 38.4619 29.2069H36.13V30.7931H38.4619Z'
					fill='white'
				/>
				<path
					d='M31.7607 30.7932H34.3039V29.2069H30.542L31.7607 30.7932Z'
					fill='white'
				/>
			</svg>
		);
	}

	if (variant === 'GHS') {
		return (
			<svg
				width='60'
				height='60'
				viewBox='0 0 60 60'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<rect
					width='60'
					height='60'
					rx='30'
					fill='#392E94'
				/>
				<g clipPath='url(#clip0_8210_55029)'>
					<path
						d='M30 44C37.732 44 44 37.732 44 30C44 22.268 37.732 16 30 16C22.268 16 16 22.268 16 30C16 37.732 22.268 44 30 44Z'
						fill='white'
					/>
					<path
						d='M35.0001 32.086C34.7577 31.9787 34.4826 31.972 34.2352 32.0675C33.9879 32.1629 33.7886 32.3527 33.6811 32.595C33.3662 33.3092 32.8507 33.9165 32.1973 34.3434C31.5439 34.7704 30.7806 34.9984 30.0001 35C29.8389 34.9938 29.6782 34.9775 29.5191 34.951L31.4541 25.279C31.9699 25.4772 32.4393 25.7795 32.8331 26.167C33.1879 26.526 33.474 26.9469 33.6771 27.409C33.7301 27.5299 33.8066 27.6391 33.902 27.7302C33.9974 27.8214 34.11 27.8928 34.2331 27.9403C34.3563 27.9878 34.4876 28.0104 34.6195 28.0069C34.7515 28.0034 34.8814 27.9738 35.0019 27.9198C35.1223 27.8658 35.2309 27.7885 35.3213 27.6923C35.4117 27.5962 35.4822 27.4831 35.5287 27.3596C35.5752 27.2361 35.5968 27.1045 35.5922 26.9726C35.5877 26.8407 35.557 26.711 35.5021 26.591C35.1992 25.9049 34.7724 25.2805 34.2431 24.749C33.5707 24.0834 32.7514 23.585 31.8511 23.294L32.0671 22.213C32.0936 22.0831 32.0674 21.9479 31.9943 21.8372C31.9212 21.7266 31.8071 21.6495 31.6771 21.623C31.5472 21.5965 31.412 21.6227 31.3013 21.6958C31.1907 21.769 31.1136 21.8831 31.0871 22.013L30.8761 23.07C30.0229 22.938 29.1512 22.9928 28.3212 23.2306C27.4912 23.4684 26.7228 23.8836 26.069 24.4474C25.4151 25.0113 24.8915 25.7104 24.5343 26.4964C24.1772 27.2825 23.9949 28.1367 24.0001 29V31C24.003 32.2661 24.4058 33.4988 25.1508 34.5224C25.8959 35.546 26.9452 36.3081 28.1491 36.7L27.9331 37.782C27.9072 37.912 27.9339 38.0469 28.0074 38.1571C28.0809 38.2674 28.1952 38.344 28.3251 38.37C28.358 38.3769 28.3915 38.3802 28.4251 38.38C28.5404 38.38 28.6521 38.3402 28.7414 38.2673C28.8307 38.1945 28.8921 38.093 28.9151 37.98L29.1261 36.926C30.4298 37.1295 31.7641 36.8937 32.9191 36.2557C34.0741 35.6177 34.9842 34.6139 35.5061 33.402C35.6127 33.1603 35.6193 32.8862 35.5245 32.6397C35.4297 32.3931 35.2412 32.1941 35.0001 32.086ZM26.0001 31V29C26.0001 27.9392 26.4215 26.9217 27.1717 26.1716C27.9218 25.4214 28.9392 25 30.0001 25C30.1612 25.0061 30.3219 25.0218 30.4811 25.047L28.5471 34.717C27.7983 34.4251 27.1548 33.9143 26.7004 33.2513C26.2461 32.5883 26.0021 31.8038 26.0001 31Z'
						fill='#292273'
					/>
				</g>
				<defs>
					<clipPath id='clip0_8210_55029'>
						<rect
							width='32'
							height='32'
							fill='white'
							transform='translate(14 14)'
						/>
					</clipPath>
				</defs>
			</svg>
		);
	}

	return (
		<svg
			width='60'
			height='60'
			viewBox='0 0 60 60'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...rest}
		>
			<rect
				width='60'
				height='60'
				rx='30'
				fill='#0095B0'
			/>
			<g clipPath='url(#clip0_8210_37874)'>
				<path
					d='M30 14C21.163 14 14 21.163 14 30C14 38.836 21.163 46 30 46C38.837 46 46 38.836 46 30C46 21.163 38.837 14 30 14Z'
					fill='#07849C'
				/>
				<path
					d='M28.9949 39.236V37.046C27.5719 37 26.1489 36.594 25.3369 36.052L25.9459 33.929C26.8269 34.449 28.0919 34.923 29.4679 34.923C30.8909 34.923 31.8629 34.223 31.8629 33.139C31.8629 32.122 31.0719 31.468 29.4009 30.858C27.0299 30.001 25.4939 28.917 25.4939 26.816C25.4939 24.874 26.8489 23.383 29.1299 22.977V20.764H30.9829V22.864C32.4059 22.909 33.3769 23.248 34.0989 23.609L33.4899 25.687C32.9479 25.438 31.9539 24.918 30.4189 24.918C28.8379 24.918 28.2729 25.731 28.2729 26.499C28.2729 27.425 29.0849 27.944 31.0049 28.713C33.5339 29.661 34.6629 30.881 34.6629 32.891C34.6629 34.81 33.3309 36.504 30.8469 36.911V39.237L28.9949 39.236Z'
					fill='white'
				/>
			</g>
			<defs>
				<clipPath id='clip0_8210_37874'>
					<rect
						width='32'
						height='32'
						fill='white'
						transform='translate(14 14)'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};
